import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit } from "@ui-seeker/utils"

import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals"
import { useDigitalShelfRoleConfig } from "../../@hooks"
import { digitalShelfEvolutionFilters, digitalShelfSubmittedFilters } from "../../@signals"


export default function useDigitalShelfTableData() {

	const { showToast } = useAppToast()
	const { urlApi } = useDigitalShelfRoleConfig()

	const data = useSignal({})
	const summaryData = useSignal([])
	const aggregations = useSignal([])
	const digitalShelfChangeResults = useSignal(false)

	useEffect(() => {
		if (isLoadingCommonFilters.value) {
			digitalShelfEvolutionFilters.value = {}
			digitalShelfChangeResults.value = false
			postSubmit(urlApi, { ...commonFiltersValue.value }).then(res => batch(() => {
				digitalShelfSubmittedFilters.value = commonFiltersValue.peek()
				data.value = res.data
				summaryData.value = res.summaryData
				aggregations.value = res.aggregations
				isLoadingCommonFilters.value = false
			})).catch(() => {
				isSystemBusy.value = true
				isLoadingCommonFilters.value = false
			})
		}
	}, [isLoadingCommonFilters.value])

	const handleChangeResults = (e) => {
		digitalShelfChangeResults.value = e.target.checked
	}

	return {
		data: data.value,
		summaryData: summaryData.value,
		aggregations: aggregations.value,
		digitalShelfChangeResults: digitalShelfChangeResults.value,

		handleChangeResults
	}
}